// the default iterable tracking domain that will be used for link shortening,
// if our users do not set their own custom domain
export const DEFAULT_LINK_SHORTENING_TRACKING_DOMAIN = process.env.LINK_SHORTENING_TRACKING_DOMAIN;

export const SETTINGS_DISPLAY_CONTENT = {
  unsetOptions: 'None',
  unsetText: 'Not set',
  message: {
    disabled:
      'This project has disabled opt out instructions. This can negatively impact your deliverability.',
    encodingHelpText:
      "Encoding will be automatically selected based on your message's character set",
    globalSmsHelpText:
      'Some users will receive a link to opt-out instead of reply to opt-out instructions.',
    gsm7Encoding: 'GSM-7 Encoding',
    handlebarsRestrictionText: 'Save and preview for accurate character count.',
    handlebarsTooltipText: 'Insert snippet',
    labelText: 'Message',
    optOutOnAllMessages:
      "These opt-out instructions are sent with every SMS campaign. You've optimized deliverability, but can change send frequency in project settings.",
    optOutOnFirstMessageOnly:
      'These opt-out instructions are sent with the first SMS campaign only. You can change send frequency in project settings to optimize deliverability.',
    placeholder: 'Message',
    ucs2Encoding: 'UCS-2 Encoding',
  },
  sender: {
    labelText: 'Sender',
    placeholder: 'Select a sender...',
  },
  shortenAndTrackLinks: {
    checkboxLabel: 'Shorten links to enable click tracking and custom link parameters',
    exampleLink: `https://${DEFAULT_LINK_SHORTENING_TRACKING_DOMAIN}/-KT~2NMwZ`,
    helpText: 'Example of a shortened link:',
    labelText: 'Shorten and track',
    noDomainsErrorText:
      'This project will use Iterable’s default domain. Visit Settings > Domains to setup custom tracking domains.',
  },
  disabledContactCard: 'To add a contact card, remove your media.',
  disabledMediaUrl: 'To add a media url, remove your contact card.',
  MmsNotAvailable: 'Please contact your CSM to purchase MMS.',
};

export const getShortenedExampleLink = (domain: string) =>
  `https://${domain || DEFAULT_LINK_SHORTENING_TRACKING_DOMAIN}/-KT~2NMwZ`;

export const PREVIEWER_CONTENT = {
  optOutToggleTooltip:
    "Toggle to display or hide the opt-out message in the SMS preview. This won't affect the actual inclusion of the opt-out text in your messages, only the preview.",
  characterCountTooltip:
    'Character count determines number of message segments. Multiple segments are typically delivered as a single message.',
};

const ID = 'template-editor-sms-preview';
export const TEMPLATE_EDITOR_SMS_PREVIEW_PANE_ID = `${ID}-pane`;
export const TEMPLATE_EDITOR_SMS_PREVIEW_REFRESH_BUTTON = `${ID}-refresh-button`;
export const TEMPLATE_EDITOR_SMS_PREVIEW_TYPE_SELECTOR = `${ID}-type-selector`;
export const TEMPLATE_EDITOR_SMS_PREVIEW_DATA_MESSAGE = `${ID}-data-message`;
export const TEMPLATE_EDITOR_SMS_PREVIEW_CHAR_COUNT = `${ID}-char-count`;
export const TEMPLATE_EDITOR_SMS_PREVIEW_SEG_COUNT = `${ID}-seg-count`;
export const TEMPLATE_EDITOR_SMS_PREVIEW_SHORTEN_TRACK = `${ID}-shorten-track`;
